import { useIntl } from 'react-intl';
import { Rule } from 'antd/lib/form';
import validatorPattern from '@/utils/validatorPattern';

const useDefaultOnlyNumberRule = (): Rule => {
  const intl = useIntl();

  return {
    pattern: /^\d+$/,
    validator: ({ pattern }, value) => {
      if (!value) return Promise.resolve();

      if (pattern && validatorPattern(pattern, String(value))) {
        return Promise.resolve();
      }
      return Promise.reject();
    },
    message: intl.formatMessage({
      id: 'commons.form.errors.invalidField',
    }),
  };
};

export default useDefaultOnlyNumberRule;
